import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Hooks } from "@xt/xtbase";
import styles from "./index.module.scss";
import settingImg from "@/assets/images/account/settingImg.svg";
import marketing from "@/assets/images/note/marketing.svg";
import { Modal, Select, message, Switch } from "antd";
import { getUserNoticeConfigList, get_noticeLang, putUserNoticeConfig, put_noticeLang } from "@/api/xt-messgae";
import { axiosThrottle } from "@/utils/method";
import { waitRes } from "@/utils/axios";

const { useTranslation } = Hooks;

// 与项目语言一致：英语、葡语、阿拉伯语
const langs = [
  { label: "English", value: "en" },
  { label: "Português", value: "pt" },
  { label: "العربية", value: "ar" },
];

const NotificationSetting: React.FC = () => {
  const t = useTranslation();
  const [visible, setVisible] = useState(false);
  const [selectVal, setSelectVal] = useState("");
  const [langStr, setLangStr] = useState("");
  const [switchStatus, setSwitchStatus] = useState(true);

  useEffect(() => {
    getLang();
    getNoticeConfig();
  }, []);

  const getLang = async () => {
    const res = await get_noticeLang();
    setSelectVal(res.lang);
    const label = langs.find((lang) => lang.value == res.lang)?.label || "";
    setLangStr(label);
  };

  const getNoticeConfig = async () => {
    await getUserNoticeConfigList({
      errorPop: true,
      params: { channel: "EMAIL", type: "SPREAD" },
    }).then((res) => {
      if (!res.length) setSwitchStatus(true);
      else setSwitchStatus(res[0].enabled);
    });
  };

  const langChange = () => setVisible(true);
  const handleChange = (value: string) => setSelectVal(value);

  const saveChange = axiosThrottle(async (unlock) => {
    const { err } = await waitRes(put_noticeLang, { data: { lang: selectVal }, errorPop: true });
    unlock();
    if (err) return;
    message.success(t("account.success"));
    setVisible(false);
    getLang();
  });

  const onChange = async (checked: boolean) => {
    await putUserNoticeConfig({
      errorPop: true,
      successPop: true,
      data: { enabled: checked, channel: "EMAIL", type: "SPREAD" },
    });
    setSwitchStatus(checked);
  };

  return (
    <div className={styles.main}>
      <div className={styles.title}>{t("notice.setting")}</div>
      <div className={[styles.list, styles.mt0].join(" ")}>
        <div className={styles.listLeft}>
          <img src={settingImg} alt="lang" />
          <div className={styles.accountSign}>
            <div className={styles.accountSignHeader}>{t("notice.lang")}</div>
            <div className={styles.accountSignFooter}>{t("notice.langDec")}</div>
          </div>
        </div>
        <div className={styles.listRight}>
          <div className={styles.tip}>{langStr}</div>
          <div className={styles.btn} onClick={langChange}>
            {t("account.change")}
          </div>
        </div>
      </div>
      <div className={styles.list}>
        <div className={styles.listLeft}>
          <img src={marketing} alt="marketing" />
          <div className={styles.accountSign}>
            <div className={styles.accountSignHeader}>{t("market.title")}</div>
            <div className={styles.accountSignFooter}>{t("market.dec")}</div>
          </div>
        </div>
        <div className={styles.listRight}>
          <Switch className={styles.switchStyle} checked={switchStatus} size="default" onChange={onChange} />
        </div>
      </div>

      <Modal
        className={[styles["common_modal"], styles["setting_modal"]].join(" ")}
        open={visible}
        title={t("notice.changeLang")}
        width={500}
        footer={null}
        onCancel={() => setVisible(false)}
      >
        <div className={styles.tip}>{t("notice.langDec")}</div>
        <div className={styles.tipLabel}>{t("notice.lang")}</div>
        <Select style={{ width: "100%" }} value={selectVal} onChange={handleChange} options={langs} />
        <div className={styles.saveBtn} onClick={saveChange}>
          {t("account.confirm")}
        </div>
      </Modal>
    </div>
  );
};

export default observer(NotificationSetting);
